import { useDashboardRequest } from './useDashboardRequest';

// What the landing page needs to know about the person looking (GET warning-dashboard/my-view):
//   view               'ogd', 'cro' or 'all' - which card list it starts with (see metricViews.js). `null` only while the first answer
//                      is on its way. If it cannot be worked out the person simply gets every card - a missing answer must never leave
//                      the page with fewer cards than before.
//   performanceMetrics false only when Finance has switched Performance Metrics off for this person's department (and they are not an
//                      exception). Anything else - true, missing (an older answer), or a failed request - means they see it: a
//                      missing answer must never hide something.
//   croWorkflow        the same for the CRO Workflow section and the CRO Pending Tasks page ("Who can see CRO Workflow" on Manage access):
//                      true / false when the server said so, `null` when it did not (an older server, a failed request, still loading) - then
//                      the page falls back to what it did before this was a choice: everyone except OGD staff sees it (see showCroWorkflow).
export const useMyView = () => {
  const { data, error } = useDashboardRequest('warning-dashboard/my-view');
  if (data) {
    return {
      view: ['ogd', 'cro', 'all'].includes(data.view) ? data.view : 'all', // an answer without a known list = everything
      performanceMetrics: data.performanceMetrics !== false,
      croWorkflow: typeof data.croWorkflow === 'boolean' ? data.croWorkflow : null,
    };
  }
  if (error) return { view: 'all', performanceMetrics: true, croWorkflow: null };
  return { view: null, performanceMetrics: true, croWorkflow: null };
};

// Does this person get the CRO Workflow section? `croWorkflow` is the server's answer (true/false) or null when there is none; with no
// answer the old fixed rule applies - OGD staff are never a student's CRO, so the section was left out for them. Pure, so it is tested.
export const canSeeCroWorkflow = (croWorkflow, isOgd) => (typeof croWorkflow === 'boolean' ? croWorkflow : !isOgd);

export default useMyView;
